import { useEffect, useState } from "react";
import { Radar, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export const TrackingSettingsCard = () => {
  const [value, setValue] = useState("");
  const [saved, setSaved] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/tracking/settings").then((r) => { setValue(String(r.data.idle_alert_min)); setSaved(r.data.idle_alert_min); }).catch(() => {});
  }, []);

  const n = Number(value);
  const valid = Number.isInteger(n) && n >= 5 && n <= 240;
  const save = async (e) => {
    e.preventDefault();
    if (!valid || busy) return;
    setBusy(true);
    try {
      const { data } = await api.put("/tracking/settings", { idle_alert_min: n });
      setSaved(data.idle_alert_min);
      toast.success(`Próg postoju ustawiony na ${data.idle_alert_min} min`);
    } catch {
      toast.error("Nie udało się zapisać progu postoju");
    } finally { setBusy(false); }
  };

  return (
    <section className="border border-zinc-900 p-6" data-testid="tracking-settings">
      <div className="font-label mb-2">// Śledzenie kurierów</div>
      <div className="flex items-start justify-between gap-6 flex-wrap">
        <div className="flex-1 min-w-[260px]">
          <h3 className="font-heading font-black text-xl uppercase tracking-tight mb-2 flex items-center gap-2"><Radar className="w-5 h-5 text-brand" />Próg alertu postoju</h3>
          <p className="text-sm text-zinc-600">Po ilu minutach postoju kuriera w jednym miejscu (przy niedostarczonych paczkach) ma pojawić się alert na mapie i w powiadomieniach. Zakres 5–240 min.</p>
          <p className="text-xs font-mono text-zinc-500 mt-2" data-testid="tracking-settings-current">Aktualnie: {saved != null ? `${saved} min` : "…"}</p>
        </div>
        <form onSubmit={save} className="flex items-end gap-2">
          <label className="block">
            <span className="font-label text-[10px] block mb-1">Minuty</span>
            <input type="number" min={5} max={240} step={1} value={value} onChange={(e) => setValue(e.target.value)} data-testid="tracking-idle-input"
              className={`w-28 h-11 px-3 border font-mono text-base outline-none focus:ring-2 focus:ring-zinc-900 ${valid ? "border-zinc-900" : "border-red-500"}`} />
          </label>
          <button type="submit" disabled={!valid || busy || n === saved} data-testid="tracking-idle-save"
            className="h-11 px-4 inline-flex items-center gap-2 bg-zinc-900 text-white text-sm font-heading font-black uppercase tracking-wider disabled:opacity-40 hover:bg-brand transition-colors">
            <Save className="w-4 h-4" />Zapisz
          </button>
        </form>
      </div>
    </section>
  );
};
